<template>
  <Modal 
    :visible="visible"
    :id="'modal-confirm'"
    z-index="99999999"
    :closeOnExternalClick="false"
  >
    <template #header>
      {{ config?.title || 'Confirm' }}
    </template>
    <template #content>
      <v-row class="ma-3">
        {{ config?.text || 'Are you sure you want to do this action?' }}
      </v-row>
    </template>
    <template #footer>
      <v-row class="justify-end ma-3">
        <CustomButton :level="$enums.ButtonLevels.Secondary" class="mr-3" @click="onCancel">
          {{ config?.cancelButtonText || 'Cancel' }}
        </CustomButton>
        <CustomButton :level="$enums.ButtonLevels.Primary" @click="onConfirm">
          {{ config?.confirmButtonText || 'Confirm' }}
        </CustomButton>
      </v-row>
    </template>
  </Modal>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { ConfirmModalConfig } from '@/types';
import Modal from '@/components/UIElements/Modal.vue';
import CustomButton from '@/components/UIElements/CustomButton.vue';

@Options({
  components: {
    Modal,
    CustomButton
  },
})
export default class ModalConfirm extends Vue {
  get visible():boolean {
    return this.$store.getters['modals/getVisibilitConfirmModal']
  }

  get config():ConfirmModalConfig | undefined {
    return this.$store.getters['modals/getConfirmModalConfig']
  }

  onCancel() {
    if(this.config?.onCancel) {
      this.config.onCancel();
    }
    this.$store.dispatch('modals/closeAskConfirmation');
  }

  onConfirm() {
    if(this.config?.onConfirm) {
      this.config.onConfirm();
    }
    this.$store.dispatch('modals/closeAskConfirmation');
  }
}
</script>
<style lang="scss" scoped>
</style>

